module.exports = __webpack_public_path__ + "static/img/fluent-folder-zip-24-regular.ec7caa61.svg";